import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type {
  Step1FormData,
  Step2FormData,
  Step3FormData,
} from "~/modules/Router/Onboarding/types";

export type CreateCommunityReducerState = {
  categoryId: string;
  step: 0 | 1 | 2 | 3 | 4;
  title: string | null;
  description: string | null;
  subdomain: string | null;
  coverImageUrl: string | null;
  profileImageUrl: string | null;
  nickname: string | null;
};

export const initialState: CreateCommunityReducerState = {
  categoryId: "0",
  step: 0,
  title: null,
  description: null,
  subdomain: null,
  coverImageUrl: null,
  profileImageUrl: null,
  nickname: null,
};

export const createCommunitySlice = createSlice({
  name: "createCommunity",
  initialState,
  reducers: {
    setCategoryId: (
      state: CreateCommunityReducerState,
      action: PayloadAction<string>,
    ) => {
      state.categoryId = action.payload;
    },
    back: (
      state: CreateCommunityReducerState,
      action: PayloadAction<0 | 1 | 2 | 3 | "auto">,
    ) => {
      if (state.step <= 0) {
        history.back();
      } else if (action.payload !== "auto") {
        state.step = action.payload;
      } else {
        state.step = (state.step - 1) as 0 | 1 | 2 | 3;
      }
    },
    submitStep0: (
      state: CreateCommunityReducerState,
      action: PayloadAction<{ categoryId: string }>,
    ) => {
      state.categoryId = action.payload.categoryId;
      state.step = 1;
    },
    submitStep1: (
      state: CreateCommunityReducerState,
      action: PayloadAction<Step1FormData>,
    ) => {
      state.title = action.payload.title;
      state.description = action.payload.description;
      state.subdomain = action.payload.subdomain;
      state.step = 2;
    },
    submitStep2: (
      state: CreateCommunityReducerState,
      action: PayloadAction<Step2FormData>,
    ) => {
      state.coverImageUrl = action.payload.coverImageUrl;
      state.profileImageUrl = action.payload.profileImageUrl;
      state.step = 3;
    },
    submitStep3: (
      state: CreateCommunityReducerState,
      action: PayloadAction<Step3FormData>,
    ) => {
      state.nickname = action.payload.nickname;
      state.step = 4;
    },
    reset: (state: CreateCommunityReducerState) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  back,
  submitStep0,
  submitStep1,
  submitStep2,
  submitStep3,
  reset,
} = createCommunitySlice.actions;

export default createCommunitySlice.reducer;
